export class MockDocument {
  createElement = jasmine.createSpy('createElement');
  execCommand = jasmine.createSpy('execCommand');
  activeElement = null;
  body = {
    appendChild: jasmine.createSpy('appendChild')
  };
}
